import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="premium-footer">
      <div className="container">
        <div className="footer-grid">

          {/* ── Brand Column ── */}
          <div className="footer-brand-col">
            <Link to="/">
              <img
                src="/img/Logo.png"
                alt="Softwood Pvt. Ltd."
                className="footer-logo"
              />
            </Link>
            <p className="footer-manifesto">
              Softwood pairs a trusted supplier network with its own production floor in Lahore — garments made and managed for brands in more than 20 countries since 2008. One partner, from the first sample to the final shipment.
            </p>
            <div className="footer-socials">
              <a href="https://www.facebook.com/Softwoodtextiles/" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                <i className="fa fa-facebook"></i>
              </a>
              <a href="https://www.linkedin.com/company/softwood" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                <i className="fa fa-linkedin"></i>
              </a>
            </div>
          </div>

          {/* ── Capabilities Column ── */}
          <div className="footer-links-col">
            <h5 className="footer-heading">Capabilities</h5>
            <ul className="footer-link-list">
              <li><Link to="/sourcing">Sourcing</Link></li>
              <li><Link to="/production">Production</Link></li>
              <li><Link to="/sustainability">Sustainability</Link></li>
            </ul>
          </div>

          {/* ── Company Column ── */}
          <div className="footer-links-col">
            <h5 className="footer-heading">Company</h5>
            <ul className="footer-link-list">
              <li><Link to="/about-us">About Us</Link></li>
              <li><Link to="/careers">Careers</Link></li>
              <li><Link to="/blog">The Journal</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>

          {/* ── Global Offices Column ── */}
          <div className="footer-contact-col">
            <h5 className="footer-heading">Global Network</h5>

            <div className="footer-office">
              <span className="office-title">Headquarters — Pakistan</span>
              <p>20 Km Ferozepur Road<br />Youhanabad Lahore, Pakistan</p>
            </div>

            <div className="footer-office">
              <span className="office-title">European Office — France</span>
              <p>20 Rue Sandro Botticelli<br />68260, Kingersheim, France</p>
            </div>

            <div className="footer-direct-lines">
              <a href="tel:+924235951191"><i className="fa fa-phone"></i> +92-4235951191/92</a>
              <a href="mailto:info@softwoodtextiles.com"><i className="fa fa-envelope"></i> info@softwoodtextiles.com</a>
            </div>
          </div>

        </div>

        {/* ── Copyright Bar ── */}
        <div className="footer-bottom">
          <div className="footer-divider"></div>
          <div className="footer-bottom-content">
            <p>© {new Date().getFullYear()} Softwood Pvt. Ltd. All rights reserved.</p>
            <div className="footer-legal-links">
              <Link to="#">Privacy Policy</Link>
              <Link to="#">Terms of Service</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;